import React, { useEffect, useState, useContext } from "react"
import { useParams, withRouter } from "react-router-dom"
import { Row, Col, Container, Modal, ModalHeader, ModalFooter, ModalBody, Button } from "reactstrap"
import { isEmpty, head } from "lodash"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ApiService from "../../data/services/ApiService"
import { GeneralContext } from "../../context/"
import { getImagesOfProduct } from "../../helpers/utils"
import ProductCard from "../../components/Common/ProductCard"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

const ProductDetail = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading, setCartItemsCount } = generalContext
    const { slug } = useParams()
    const { productId } = useParams()
    const [product, setProduct] = useState({})
    const [productQuantity, setProductQuantity] = useState(1)
    const [firstVariantValue, setFirstVariantValue] = useState("")
    const [secondVariantValue, setSecondVariantValue] = useState("")
    const [thirdVariantValue, setThirdVariantValue] = useState("")

    const [cartAlertModal, setCartAlertModal] = useState(false)
    const toggleCartAlertModal = () => setCartAlertModal(!cartAlertModal)

    useEffect(() => {
        (async () => {
            setLoading(true)
            const response = await ApiService.getProductById(productId, true)
            setProduct(response.data.product)
            setLoading(false)
        })()
    }, []) // eslint-disable-line

    const shareProduct = async () => {
        const productPublicUrl = `https://mitiendasocial.com/producto/`
        const shareText = `Este%20producto%20te%20va%20a%20encantar%20%F0%9F%A4%A9%F0%9F%A4%A9%20`
        window.open(`https://api.whatsapp.com/send?text=${shareText}${productPublicUrl}${product.supplierCode}`)
    }

    const addToCart = async () => {
        try {
            setLoading(true)
            const data = {
                productId: product.id,
                quantity: productQuantity,
                firstVariantValue,
                secondVariantValue,
                thirdVariantValue,
            }
            const response = await ApiService.addToCart(data)
            // Set el numero de articulos que el usuario tiene en su carrito
            setCartItemsCount(response.data.itemsOnCart)
            setProductQuantity(1)
            setFirstVariantValue("")
            setSecondVariantValue("")
            setThirdVariantValue("")
            toastr.success("Producto agregado al carrito.", "¡Éxito!")
        } catch (error) {
            toggleCartAlertModal()
        } finally {
            setLoading(false)
        }
    }

    const onChangeQuantity = (quantity) => {
        setProductQuantity(quantity)
    }

    const onChangeFirstVariant = (value) => {
        setFirstVariantValue(value)
    }

    const onChangeSecondVariant = (value) => {
        setSecondVariantValue(value)
    }

    const onChangeThirdVariant = (value) => {
        setThirdVariantValue(value)
    }

    const addToCartButtonDisabled = () => {
        if (!isEmpty(product)) {
            if (!isEmpty(head(product.variants).firstOption.label)) {
                if (isEmpty(firstVariantValue) || firstVariantValue === "0") {
                    return true
                }
            }
            if (!isEmpty(head(product.variants).secondOption.label)) {
                if (isEmpty(secondVariantValue) || secondVariantValue === "0") {
                    return true
                }
            }
            if (!isEmpty(head(product.variants).thirdOption.label)) {
                if (isEmpty(thirdVariantValue) || thirdVariantValue === "0") {
                    return true
                }
            }
        }
        return false
    }

    const resetCart = async () => {
        try {
            toggleCartAlertModal()
            setLoading(true)
            const response = await ApiService.resetCart()
            if (response.data.success) {
                setCartItemsCount(response.data.itemsOnCart)
                addToCart()
            }
        } catch (error) {
            toastr.error(error.response.data.message, "Error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                {product && (
                    <Container fluid>
                        <Breadcrumbs
                            title={product.catalog && product.catalog.name}
                            breadcrumbItem={product.name}
                            parentLink={slug ? `/catalogos/detalles/${slug}/productos` : '/discovery'}
                        />
                        <Row>
                            <Col
                                sm={12}
                                style={{
                                    textAlign: "center",
                                    marginBottom: "15px",
                                }}
                            >
                                <ProductCard
                                    photos={getImagesOfProduct(
                                        product.gallery || []
                                    )}
                                    code={`${product.supplierCode ? `Código ${product.supplierCode}` : ''}`}
                                    price={`${product.wholeSalePrice || 0}`}
                                    productName={product.name}
                                    supplierName={product.supplier ? product.supplier.nombreComercial : ''}
                                    description={product.description}
                                    showVariants
                                    variants={product.variants}
                                    firstVariantValue={firstVariantValue}
                                    secondVariantValue={secondVariantValue}
                                    thirdVariantValue={thirdVariantValue}
                                    onChangeFirstVariant={onChangeFirstVariant}
                                    onChangeSecondVariant={onChangeSecondVariant}
                                    onChangeThirdVariant={onChangeThirdVariant}
                                    quantity={productQuantity}
                                    onChangeQuantity={onChangeQuantity}
                                    showFooterOptions
                                    shareButtonText="Compartir"
                                    shareButtonAction={shareProduct}
                                    addToCartButtonText="Agregar al carrito"
                                    addToCartButtonAction={addToCart}
                                    addToCartButtonDisabled={addToCartButtonDisabled()}
                                />
                            </Col>
                        </Row>
                    </Container>
                )}
            </div>
            <div>
                <Modal isOpen={cartAlertModal} toggle={toggleCartAlertModal}>
                    <ModalHeader toggle={toggleCartAlertModal}>Producto de otro proveedor</ModalHeader>
                    <ModalBody>
                        Estás agregando un producto de un proveedor diferente, si deseas continuar, vamos a resetear tu carrito.
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleCartAlertModal}>Cancelar</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={resetCart}>Resetear carrito</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    )
}

export default withRouter(ProductDetail)
